<template>
    <div class="page-content header-clear-medium">

		<div v-if="loading">		
			<NewsSekeleton :count="3" />
		</div>
		<div v-else>
			<div class="card card-style" :class="{ 'idle-post' : !postsReadLocal.includes(parseInt(item.id)) }" v-for="item in posts" :key="item.id">
				<div class="content mt-2">
					<div title="Caption Title" class="card card-style bg-14 mb-3 mx-0" style="height:400px" data-gallery="gallery-3" :style="{ 'background-image': 'url('+item._embedded['wp:featuredmedia'][0]['source_url']+')', 'object-fit': 'fill' }">					
					</div>
					
					<h5 class="color-highlight font-14 mb-1">{{ item.date | getDateIndo }}</h5>
					<h3 v-html="item.title.rendered"></h3>
					<div class="d-flex mb-2">
						<div class="d-flex flex-row">
							<i class="bi bi-person-circle color-blue-dark font-16"></i>
							<p class="font-16 ms-2"><strong>Berita</strong></p>
						</div>
						<!-- <div class="d-flex flex-row ms-3">
							<i class="bi bi-eye-fill color-blue-dark font-16"></i>
							<p class="font-16 ms-2"><strong>{{ item.count_read }}</strong></p>
						</div> -->
					</div>
					
					<!-- <div class="mb-3">{{ item.content_string.substr(0, 160) }}{{ item.content_string | checkReadMore }}</div> -->
					<div class="mb-3" v-html="item.excerpt.rendered"></div>

					<!-- <div>
						<a 
							v-for="itemTag in item.tags" :key="itemTag.id"
							href="#" 
							class="btn-xxs btn border-blue-dark color-blue-dark me-1"
						>{{ itemTag.name }}</a>
					</div> -->

					<div class="mt-3">
						<router-link :to="{ name: 'news.detail', params: { slug: item.slug }}" class="btn-full btn-s btn gradient-blue">Selengkapnya</router-link>
					</div>
				</div>
			</div>

			<!-- <div v-show="post.next_page_url != null" class="content">
				<a href="javascript:void(0)" @click="getDataPostLoadMore(post.next_page_url)" class="btn-full btn-s btn gradient-blue"><i class="bi bi-box-arrow-down pe-2 ms-n1"></i> Load More</a> -->
			<div v-show="nextPage <= total_pages" class="content">
				<a href="javascript:void(0)" @click="getDataPostLoadMore(nextPage)" class="btn-full btn-s btn gradient-blue"><i class="bi bi-box-arrow-down pe-2 ms-n1"></i> Load More</a>
			</div>
		</div>
        
    </div>
</template>

<script>
import { 
	mapMutations, 
	mapActions, mapState 
} from 'vuex'

import NewsSekeleton from "../components/skeleton/NewsSekeleton.vue";

export default {
    name: 'News',
    components: {
		NewsSekeleton
    },
    data() {
        return {
			nextPage : 2
        }
    },
    async created() {
			this.SET_LOADING()
			let tempPosts = await this.getPost()
			await this.readAllPostNotificaion(tempPosts.headers['x-wp-total'])
			this.CLEAR_LOADING()
    },
    methods: {
			...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
			...mapActions('postWp', ['getPost', 'getPostLoadMore']),
			...mapActions('notificationLocal', ['readAllPostNotificaion']),
			async getDataPostLoadMore(next_page_url) {
				let tempPosts = await this.getPostLoadMore(next_page_url)
				this.nextPage++
			},
    },
    computed: {
			...mapState({
					loading: state => state.loading
			}),
			...mapState('postWp', {
				// post: state => state.post,
				total_pages: state => state.total_pages,
				posts: state => state.posts,
			}),
			...mapState('notificationLocal', {
					postsReadLocal: state => state.postsReadLocal
			}),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
.idle-post {
	background-color: #B9D7FF !important; 
	color: #FFF !important;
}
</style>
